import React from 'react';
import styled from 'styled-components';

/**
 * Full-bleed banner using a relative image from src/assets/images
 * (imported by callers) or a public path like /images/hero-home.jpg.
 */
const Wrap = styled.section`
  position: relative;
  min-height: ${p => p.$minHeight || '70vh'};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  overflow: hidden;
  padding: ${p => p.$padding || '6rem 1.25rem 4rem'};
`;

const Bg = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${p => p.$src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Scrim = styled.div`
  position: absolute;
  inset: 0;
  background: ${p =>
    p.$scrim ||
    'rgba(15, 23, 42, 0.72)'};
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: ${p => p.$maxWidth || '820px'};
  margin: 0 auto;
`;

const BannerHero = ({
  imageSrc,
  children,
  minHeight,
  padding,
  maxWidth,
  scrim,
  as = 'section',
  className,
}) => (
  <Wrap
    as={as}
    className={className}
    $minHeight={minHeight}
    $padding={padding}
    aria-label="Page banner"
  >
    <Bg $src={imageSrc} role="img" aria-hidden="true" />
    <Scrim $scrim={scrim} aria-hidden="true" />
    <Content $maxWidth={maxWidth}>{children}</Content>
  </Wrap>
);

export default BannerHero;

/** Public-folder relative URL helper: /images/<filename> */
export const publicImage = (filename) =>
  `${process.env.PUBLIC_URL || ''}/images/${filename}`;
